import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLock04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 8v1.708a8 8 0 1 0 12 0V8A6 6 0 0 0 6 8Zm6-4a4 4 0 0 0-4 4v.07A7.963 7.963 0 0 1 12 7c1.457 0 2.823.39 4 1.07V8a4 4 0 0 0-4-4Zm1 10a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgLock04.displayName = 'Lock04';
export default SvgLock04;
